import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import type { AppDispatch } from '../../store';
import { logout } from '../../store/auth/Actions';
import { Redirect } from 'react-router-dom';

const Logout = () => {
    const authenticated = useSelector((state: any) => state.auth.authenticated);
    const dispatch = useDispatch<AppDispatch>();

    if (authenticated) {
        dispatch(logout());
    }

    return <>{!authenticated && <Redirect to="/login" />}</>;
};

export default Logout;
